import React from 'react'
import { StyledHeadline, StyledFeatureLabel, StyledHeadlineText } from './FeatureHeadline.styled'
import { TheWestMark } from 'component-library/logos/TheWestMark/TheWestMark'
import { colors } from 'component-library/__styling/settings'

export interface FeatureHeadlineProps {
    text: string
    isExclusive: boolean
}

export const FeatureHeadline: React.FC<FeatureHeadlineProps> = ({ text, isExclusive }) => (
    <StyledHeadline itemProp="headline" isExclusive={isExclusive}>
        {isExclusive && (
            <StyledFeatureLabel>
                <TheWestMark fill={colors.thewest.westblue} width={22} height={19} />
                <span>Exclusive</span>
            </StyledFeatureLabel>
        )}
        <StyledHeadlineText>{text}</StyledHeadlineText>
    </StyledHeadline>
)
